import { render, staticRenderFns } from "./TagColorPicker.vue?vue&type=template&id=685781e2&scoped=true&"
import script from "./TagColorPicker.vue?vue&type=script&lang=js&"
export * from "./TagColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./TagColorPicker.vue?vue&type=style&index=0&id=685781e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685781e2",
  null
  
)

export default component.exports